<template>
    <div class="row">
        <div
            class="col-sm-12"
            :class="{ 'col-md-10 col-sm-9': !wide, 'col-sm-6': wide}"
        >
            <label :for="id">{{ label }}</label>
        </div>
        <div
            class="col-xs-12 text-right"
            :class="{ 'col-md-2 col-sm-3': !wide, 'col-sm-6': wide}"
        >
            <fire-alarm-upload-preview
                v-if="value && value !== ''"
                :upload="value"
                @change="uploadChanged($event)"
            />
            <input
                :id="id"
                type="file"
                @change="handleUpload($event)"
                :accept="accept"
                class="block"
            >
        </div>
    </div>
</template>

<script>
import UploadService from "../../../services/UploadService";
import FireAlarmUploadPreview from "./FireAlarmUploadPreview.vue";

export default {
    components: {FireAlarmUploadPreview},
    props: {
        value: {
            required: false,
            default: null
        },
        label: {
            required: true,
            type: String
        },
        id: {
            required: true,
            type: String
        },
        wide: {
            default: false,
            type: Boolean,
        },
        accept: {
            type: String,
            default: 'image/*',
        }
    },
    watch: {
        value() {
            if (this.localVal !== this.value) {
                this.localVal = this.value;
            }
        }
    },
    methods: {
        handleUpload(event) {
            if (!event.target.files[0]) {
                return;
            }
            UploadService.upload(event.target.files[0], 1024)
                .then((res) => {
                    this.$emit("input", res.data.full_url);
                })
                .catch((err) => {
                    this.setErrorMessage(
                        "Failed to upload file, please try again"
                    );
                    console.error(err);
                    window.setTimeout(() => {
                        this.setErrorMessage(null);
                    }, 5000);
                });
        },
        uploadChanged(newUrl) {
            this.$emit("input", `${newUrl}?time=${Date.now()}`);
        },
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/parts/FileUploadRowComponent.vue